<div class="content">
  <!-- <img class="left" src="/images/home/styles/product2.webp" alt="product" /> -->

  <div class="texts">
    <h2>Style for Every Woman</h2>
    <h3>Versatile Designs. Premium Quality. Made to Impress.</h3>
  </div>
  <!-- <img class="right" src="/images/home/styles/product1.webp" alt="product" /> -->
</div>